export interface RollupTotal {
  count: number;
  sum: number;
  avg: number;
}

export interface RollupChild {
  orgPath: string;
  orgName?: string;
  total: RollupTotal;
}

export interface RollupResponse {
  orgPath: string;
  metric: string;
  period: string;
  total: RollupTotal;
  children?: RollupChild[];
}

export interface TrendPoint {
  period: string;
  value: number;
  label: string;
}

const MONTHS = ['2025-12', '2026-01', '2026-02', '2026-03', '2026-04', '2026-05', '2026-06'];
const MONTH_LABELS = ['Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];

export const DEMO_TREND: TrendPoint[] = MONTHS.map((m, i) => ({
  period: m,
  label: MONTH_LABELS[i],
  value: +(0.68 + Math.sin(i * 0.8) * 0.08 + i * 0.012).toFixed(3),
}));

export const DEMO_ROLLUP_ROOT: RollupResponse = {
  orgPath: '/aetc',
  metric: 'pass_rate',
  period: '2026-06',
  total: { count: 2847, sum: 2278, avg: 0.800 },
  children: [
    { orgPath: '/aetc/2af',  orgName: '2nd Air Force',          total: { count: 612, sum: 508, avg: 0.830 } },
    { orgPath: '/aetc/19af', orgName: '19th Air Force',         total: { count: 891, sum: 703, avg: 0.789 } },
    { orgPath: '/aetc/afrs', orgName: 'Air Force Recruiting',   total: { count: 448, sum: 343, avg: 0.766 } },
    { orgPath: '/aetc/arpc', orgName: 'Air Reserve Personnel',  total: { count: 317, sum: 264, avg: 0.833 } },
    { orgPath: '/aetc/aetc-a', orgName: 'AETC HQ Staff',       total: { count: 579, sum: 460, avg: 0.794 } },
  ],
};

export const DEMO_ROLLUP_2AF: RollupResponse = {
  orgPath: '/aetc/2af',
  metric: 'pass_rate',
  period: '2026-06',
  total: { count: 612, sum: 508, avg: 0.830 },
  children: [
    { orgPath: '/aetc/2af/81tw',  orgName: '81st Training Wing',   total: { count: 198, sum: 171, avg: 0.864 } },
    { orgPath: '/aetc/2af/17trw', orgName: '17th Training Wing',   total: { count: 214, sum: 174, avg: 0.813 } },
    { orgPath: '/aetc/2af/149fw', orgName: '149th Fighter Wing',   total: { count: 200, sum: 163, avg: 0.815 } },
  ],
};

export const DEMO_INSTRUCTOR_UTILIZATION = [
  { name: 'MSgt Torres',    orgPath: '/aetc/2af/81tw', sessions: 18, capacity: 20, certExpiry: '2026-09-15', domains: ['physical', 'cognitive'] },
  { name: 'TSgt Williams',  orgPath: '/aetc/2af/81tw', sessions: 12, capacity: 20, certExpiry: '2026-08-01', domains: ['psychological'] },
  { name: 'SSgt Patterson', orgPath: '/aetc/2af/17trw', sessions: 20, capacity: 20, certExpiry: '2026-07-20', domains: ['physical', 'social'] },
  { name: 'MSgt Rivera',    orgPath: '/aetc/2af/17trw', sessions: 9,  capacity: 20, certExpiry: '2026-12-10', domains: ['spiritual', 'family'] },
  { name: 'TSgt Nguyen',    orgPath: '/aetc/2af/149fw', sessions: 16, capacity: 20, certExpiry: '2027-01-05', domains: ['cognitive', 'physical'] },
];

export const DEMO_METRICS: Record<string, RollupResponse> = {
  pass_rate:     DEMO_ROLLUP_ROOT,
  attempt_count: { ...DEMO_ROLLUP_ROOT, metric: 'attempt_count', total: { count: 2847, sum: 2847, avg: 1 } },
  dq_count:      { ...DEMO_ROLLUP_ROOT, metric: 'dq_count', total: { count: 2847, sum: 142, avg: 0.05 } },
};

const DEMO_DRILL: Record<string, RollupResponse> = {
  '/aetc':      DEMO_ROLLUP_ROOT,
  '/aetc/2af':  DEMO_ROLLUP_2AF,
};

export function getDemoRollup(orgPath: string, metric: string): RollupResponse {
  const base = DEMO_DRILL[orgPath] ?? DEMO_ROLLUP_ROOT;
  return { ...base, metric };
}
